module.exports = __webpack_public_path__ + "static/img/part12.b4ac3e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/activity4/part12.png
// module id = jpJB
// module chunks = 7